import { api } from 'api'
import { path } from 'ramda'
import { TimelineShift } from 'api/shift'

interface GetCompanyShiftDetailResponse extends TimelineShift {
  shiftEndWorkApprovalDelayHours: number
}

export async function getCompanyShiftDetail({ ids }: { ids: number[] }) {
  const data = await api.post(
    '/company/graphql_dispatch/shift_detail_17608ea0',
    {
      ids,
      includeEstimate: true,
    }
  )

  const shifts = path(
    ['data', 'data', 'company', 'shiftsDetail'],
    data
  ) as GetCompanyShiftDetailResponse[]
  return shifts.map((shift) => ({
    ...shift,
    id: Number(shift.id),
  }))
}
